import SectionHeading from "@/components/primitives/SectionHeading";
import Reveal from "@/components/primitives/Reveal";
import PartnerProcess from "@/components/partners/PartnerProcess";
import FormReseller from "../Components/formsReseller";

export default function BecomeReseller() {
  return (
    <section
      id="becomeReseller"
      aria-labelledby="become-reseller-title"
      className="relative py-24 sm:py-32"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(45% 40% at 50% 0%, rgb(var(--brand) / 0.14), transparent 70%)",
        }}
      />
      <div className="container-x relative flex flex-col items-center">
        <SectionHeading
          kicker="Cadastro de parceiro"
          title={
            <span id="become-reseller-title">
              Vire um <span className="text-gradient">parceiro Alert AI</span>
            </span>
          }
          description="Preencha todos os campos obrigatórios (*) com informações precisas e atualizadas. Anexe os documentos solicitados ao final."
        />
        <div className="mt-14 w-full max-w-4xl">
          <PartnerProcess />
        </div>
        <Reveal delay={0.1} y={30} className="mt-10 flex w-full justify-center">
          <FormReseller />
        </Reveal>
      </div>
    </section>
  );
}
